<template>
    <Card class="p-4 mb-4">
        <b-overlay
            :show="loading"
            rounded="sm"
        >
            <ErrorMessage v-if="error" :value="error" class="mt-3" />

            <div>
                <h5 class="mb-3">{{ $t('pluginExtension.title') }}</h5>

                <b-form-group :label="$t('pluginExtension.selectPlaceholder')">
                    <b-form-select
                        v-model="selectedExtension"
                        :disabled="loading"
                        :options="extensionsList"
                        value-field="value"
                        text-field="text"
                        class="mb-3"
                    />
                </b-form-group>

                <div v-if="selectedExtensionComponent">
                    <component
                        :is="selectedExtensionComponent"
                        ref="extensionInstance"
                        :settings="extensionSettings"
                        :plugin="plugin"
                    />
                </div>

                <ButtonIcon
                    class="mt-3"
                    hide-label-while-loading
                    :loading="loading"
                    @click="save"
                >
                    {{ $t('save') }}
                </ButtonIcon>
            </div>
        </b-overlay>
    </Card>
</template>

<script>
    import { camelCase, upperFirst } from 'lodash';
    import pluginService from '@/services/pluginService';
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import RotatingGroupsExtension from '../extensions/RotatingGroupsExtension.vue';

    export default {
        name: 'PluginExtension',
        components: {
            RotatingGroupsExtension,
            ErrorMessage,
        },
        props: {
            plugin: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                selectedExtension: null,
                extensionsList: [],
                extensionSettings: null,
                loading: false,
                error: null,
            };
        },

        computed: {
            selectedExtensionComponent() {
                if (!this.selectedExtension) return null;
                return `${upperFirst(camelCase(this.selectedExtension))}Extension`;
            },
        },
        methods: {
            async fetchAvailableExtensions() {
                this.loading = true;
                try {
                    const response = await pluginService.fetchAvailableExtensions();
                    this.extensionsList = [{ value: null, text: this.$t('pluginExtension.noExtension') }, ...response.map(ext => ({ value: ext.value, text: ext.text }))];

                    this.selectedExtension = this.plugin.extensionType || null;
                    this.extensionSettings = this.plugin.extension || null;
                } catch (e) {
                    this.error = e.message || this.$t('errorOccurred');
                } finally {
                    this.loading = false;
                }
            },

            async save() {
                this.loading = true;
                this.error = null;
                try {
                    const settings = this.selectedExtension ? await this.$refs.extensionInstance?.getExtensionSettings?.() : null;

                    await pluginService.updatePlugin(this.plugin.id, {
                        extensionType: this.selectedExtension,
                        extension: settings,
                    });

                    this.$toastr.success(this.$t('dataSavedSuccessfully'));
                } catch (e) {
                    this.error = e.message || this.$t('errorOccurred');
                } finally {
                    this.loading = false;
                }
            },
        },
        async mounted() {
            await this.fetchAvailableExtensions();
        },
    };
</script>
